import { Paper, Stepper } from "@mantine/core"
import { IconBellRinging } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"
import type { TSession } from "@/types"
import { DateTime, icons } from "../utils"

export function SessionSteps({ session }: { session: TSession }) {
  const dtnow = Date.now()
  const { t } = useTranslation()
  const step = session.dtfinish < dtnow ? 3 : session.dtstart < dtnow ? 2 : 1

  return (
    <Paper p="md" my="md" withBorder>
      <Stepper active={step} w="auto">
        <Stepper.Step
          label={t("Created")}
          icon={<icons.Calendar />}
          completedIcon={<icons.Calendar />}
          description={<DateTime timestamp={session.created} />}
        />
        <Stepper.Step
          label={t("Start")}
          icon={<IconBellRinging />}
          completedIcon={<IconBellRinging />}
          description={<DateTime timestamp={session.dtstart} />}
        />
        <Stepper.Step
          label={step >= 3 ? t("Finished") : t("Finishes")}
          icon={<icons.Success />}
          completedIcon={<icons.Success />}
          description={<DateTime timestamp={session.dtfinish} />}
        />
      </Stepper>
    </Paper>
  )
}
